export default [
  {
    title: 'Admin.SideMenu.Configuration',
    icon: 'Settings',
    children: [
      {
        title: 'Admin.SideMenu.Configuration.ConfigurationItems',
        route: 'admin-configuration',
      },
      {
        title: 'Admin.SideMenu.Configuration.Industries',
        route: 'admin-industries',
      },
      {
        title: 'Admin.SideMenu.Configuration.Languages',
        route: 'admin-languages',
      },
      {
        title: 'Admin.SideMenu.Configuration.ScoringMultipliers',
        route: 'admin-scoring-multipliers',
      },
      {
        title: 'Admin.SideMenu.Configuration.TargetingProperties',
        route: 'admin-targeting',
      },
      {
        title: 'Admin.SideMenu.Configuration.BidStrategiesSubtypeMappings',
        route: 'admin-bid-strategy-subtype-mappings',
      },
      {
        title: 'Admin.SideMenu.Configuration.TablePresets',
        route: 'table-preset',
      },
      {
        title: 'Admin.SideMenu.Configuration.Emails',
        route: 'admin-emails',
      },
      {
        title: 'Admin.SideMenu.Configuration.Info',
        route: 'admin-info',
      },
    ],
  },
]
